import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import { devConfig } from 'config/config'; // Import development configuration

/**
 * Class representing the agent list management view.
 * @extends JetView
 */
export default class agentListManagementView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        return {
            type: 'wide',
            cols: [
                {
                    type: 'wide',
                    localId: 'inner:layout',
                    rows: [
                        {
                            view: 'toolbar', // Toolbar component
                            css: theme, // Apply theme to toolbar
                            elements: [
                                {
                                    width: 30,
                                    css: 'back-button', // CSS class for back button
                                    view: 'button', // Button component
                                    type: 'icon', // Icon button type
                                    icon: 'wxi-angle-left', // Back icon
                                    id: 'security.adminuser', // Button ID
                                    align: 'center', // Center alignment
                                    click: () => {
                                        // Click event handler
                                        this.show('../agentList'); // Navigate to agent list
                                    },
                                },
                                {
                                    css: 'user-selected', // CSS class for label
                                    view: 'label', // Label component
                                    id: 'lblTittle', // Label ID
                                    align: 'center', // Center alignment
                                },
                            ],
                        },
                        {
                            view: 'tabbar', // Tabbar component
                            localId: 'tabbar', // Local ID for tabbar
                            id: 'menu', // Tabbar ID
                            height: 35, // Height of the tabbar
                            options: [], // Options for the tabbar
                        },
                        { $subview: true }, // Placeholder for subview
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and fetches necessary data.
     */
    init() {
        const _ = this.app.getService('locale')._; // Localization service
        this.use(plugins.Menu, this.$$('tabbar')); // Use menu plugin with tabbar
        const cur_user = this.getParam('user', true); // Get current user parameter

        // Fetch client data by ID
        webix.ajax().get(
            devConfig.geturlApi() + 'Client/GetClientById', // API endpoint
            'id=' + cur_user, // Query parameter
            {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    data = JSON.parse(text); // Parse response data
                    $$('lblTittle').setValue(
                        // Set label value with user info
                        "<div class='username-active'><span class='webix_icon webix_sidebar_icon icon-user-secret'></span><div style='font-weight: normal'>" +
                            _('Agente') +
                            ': &nbsp;</div><div>' +
                            data[0].Name +
                            '</div></div>',
                    );
                },
            },
        );

        // Event listener for person selection
        this.on(
            this.app,
            'person:select',
            (person) => this.setParam('user', person.id, true), // Update user parameter
        );

        // Fetch menu data for the user
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for request
            })
            .post(
                devConfig.geturlApi() + '/Menus/GetMenuUser', // API endpoint
                '{"Menu":"AgentList","id":"' + cur_user + '"}', // Request body
                {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Error message on failure
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var menu = JSON.parse(text); // Parse menu data
                        menu.data.forEach(function (obj) {
                            obj.value = _(obj.value); // Localize menu item values
                        });
                        $$('menu').define('options', menu.data); // Define menu options
                        $$('menu').refresh(); // Refresh menu display
                    },
                },
            );
    }
}

// FILE DOCUMENTED
